import React from "react"
import "./src/styles/libs/sanitize.css"
import "./src/styles/global-styles.scss"
import "./src/styles/global-utilities.scss"
import { TrustArcBanner } from "./src/integrations/trustarc"

export const wrapRootElement = ({ element }) => (
  <>
    <TrustArcBanner />
    {element}
  </>
)
